<div fxLayout="column" class="participant-table-container">
  <div
    fxLayout="column"
    fxLayoutAlign="space-around start"
    fxFill
    *ngIf="participant?.contactType"
  >
    <div fxLayout="row" fxFill>
      <div id="column-one" fxLayout="column" fxFlex="no-grow">
        <p
          id="participant-caption"
          fxLayout="column"
          fxLayoutAlign="start start"
        >
          <span (click)="onParticipantCaptionClicked(participant)">{{
            participant.caption
          }}</span>
          <label class="readonly-label">{{ participant.contactType }}</label>
        </p>
        <div *ngFor="let participantAddress of participant.addresses">
          <fsx-text-component
            #addressField
            *ngIf="participantSpec && filingProfile"
            [caption]="participantAddress.category?.caption ?? ''"
            [helpText]="''"
            [hint]="''"
            [width]="'375px'"
            [fieldDefinition]="participantAddressFieldDefinition"
            [initialValue]="
              participantAddress | addressCaption: participantSpec:filingProfile
            "
            (formControlEmitter)="setParticipantAddressesFormControl($event)"
          ></fsx-text-component>
        </div>
      </div>

      <div fxLayout="column" fxFlex>
        <fsx-text-component
          #clientNumberField
          *ngIf="participantClientNumberInitialValue"
          [caption]="'Client No.'"
          [helpText]="''"
          [hint]="''"
          [width]="'190px'"
          [fieldDefinition]="participantClientNumberFieldDefinition"
          [initialValue]="participantClientNumberInitialValue"
          (formControlEmitter)="setParticipantClientNumberFormControl($event)"
        ></fsx-text-component>

        <div *ngFor="let participantPhone of participant.phones">
          <fsx-text-component
            #phoneField
            [caption]="participantPhone.category?.caption ?? ''"
            [helpText]="''"
            [hint]="''"
            [width]="'190px'"
            [fieldDefinition]="participantPhonesFieldDefinition"
            [initialValue]="participantPhone.fullNumber"
            (formControlEmitter)="setParticipantPhoneNumberFormControl($event)"
          ></fsx-text-component>
        </div>

        <div *ngFor="let participantEmails of participant.emails">
          <fsx-text-component
            #emailField
            [caption]="participantEmails.category?.caption ?? ''"
            [helpText]="''"
            [hint]="''"
            [width]="'190px'"
            [fieldDefinition]="participantPhonesFieldDefinition"
            [initialValue]="participantEmails.address"
            [overflowWrap]="true"
            (formControlEmitter)="setParticipantEmailsFormControl($event)"
          ></fsx-text-component>
        </div>
      </div>

      <div *ngIf="!isReadonly" fxLayout="row" fxLayoutAlign="end start">
        <mat-icon
          *ngIf="!isAssociatedParty"
          class="participant-action-icon edit-participant-icon"
          style="cursor: pointer"
          (click)="onEditParticipantIconClicked(participant)"
        ></mat-icon>
        <mat-icon
          class="participant-action-icon clear-participant-icon"
          (click)="onClearParticipantClicked()"
          style="cursor: pointer"
        ></mat-icon>
      </div>
    </div>

    <div *ngFor="let participantAlias of participantAliasInfo">
      <fsx-text-component
        #aliasField
        [caption]="participantAlias.caption"
        [helpText]="''"
        [hint]="''"
        [width]="'100%'"
        [fieldDefinition]="participantAliasFieldDefinition"
        [initialValue]="participantAlias.value"
      ></fsx-text-component>
    </div>
  </div>

  <fsx-additional-fields-component
    #additionalField
    *ngFor="let addlFieldSpec of additionalFieldSpec; let index = index"
    [additionalFieldSpec]="addlFieldSpec"
    [resolver]="resolver"
    [initialValues]="
      resolver.getAdditionalFieldInitialValue(
        addlFieldSpec,
        additionalFieldValues
      )
    "
    [existingAdditionalValues]="additionalFieldValues"
    (additionalFieldsValuesEmitter)="setAdditionalFieldValues($event)"
  ></fsx-additional-fields-component>
</div>
